import { Navigate, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Projects from './pages/Projects';
import ProjectFocus from './pages/ProjectFocus';
import Contact from './pages/Contact';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import './styles.scss';

function App() {
  return (
    <div className="app flex-column large-gap">
      <Navbar />
      <Routes>
        <Route element={<Home />} path="/"/>
        <Route element={<Projects />} path="/projects" />
        <Route element={<ProjectFocus />} path="/projects/:key" />
        <Route element={<Contact />} path="/contact"/>

        <Route element={<Navigate replace to="/" />} path="*" />
      </Routes> 
      <Footer />
    </div>
  );
}

export default App;